import styled, { keyframes } from 'styled-components';
import COLORS from '@mlb/react-patterns/style/universal.color.ts';
import Button from '@mlb/react-patterns/components/Button/button';
import { TYPES } from './components/auth/index';
import { StyledDotSVG, StyledCarousel } from '@mlb/react-patterns/components/Carousel/carousel.style';
import { TeamSummaryMatchUpWrapper } from '../TeamSummaryMatchup/TeamSummaryMatchup.style';
import GDBREAKPOINTS from '../themes/breakpoints';
import { ButtonTypes } from './components/Button';
import { ModalContainer } from '@mlb/react-patterns/components/Modal/modal.style';
import { CloseButton } from '../Overlay/overlay.style';
import Link from '@mlb/react-patterns/components/Link/link';
import { PopperWrapper, PopoverArrow } from '@mlb/react-patterns/components/Popover/popover.style';
import { ChipWrapper, ChipWrapperFlex } from '../ChipFeed/ChipFeed.style';
import { ATBAT_MODAL_BREAKPOINT } from '@gameday/components/themes/breakpoints';
import { MainWrapper, UpcomingBattersContainer } from '../PlayerDuel/components/UpcomingBatters/UpcomingBatters.style';

export const FieldVisionPlayerContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: stretch;
    flex-grow: 1;
`;

const {
    mlbBlack,
    mlbGrey2,
    blueRibbon,
    mlbWhite
} = COLORS;

const {
    XS
} = GDBREAKPOINTS;

const ChipAnim = keyframes`
  12% {
    opacity: 0;
  }
  15% {
    opacity: 1;
  }
  97% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;

const LoadingSpinnerKeyFrames = keyframes`
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
`;

export const CameraOptionsWrapper = styled.div`
    font-family: var(--gameday-primary-font);
    color: var(--gameday-secondary-font-color);

    margin-left: 16px;

    ${({ $type }) => {
        if ($type === 'single') {
            return `
                margin-left: 0;
            `;
        }
    }};

    > div {
        font-weight: 700;
        font-size: 14px;
        line-height: 14px;
        text-transform: uppercase;
        margin-top: 24px;
        margin-bottom: 24px;

        ${({ $type }) => {
        if ($type === 'single') {
            return `
                    margin-left: auto;
                    margin-right: auto;
                    width: 337px;
                `;
        }
    }};
    }
`;

export const ChipFeedWrapper = styled.div`
    width: 100%;
    max-width: 373px;
`;

export const PopoverContent = styled.div`
   width: 250px;
   height: 306px;
`;

export const CamHowWrapper = styled.div`
    display: block;
`;

export const CameraOptionsPopoverWrapper = styled.div`
    position: relative;
    display: block;
    position: absolute;
    bottom: 16px;
    right: 16px;
    width: 56px;
    height: 56px;

    .camera {
        right:0;
        bottom:0;
    }

    ${PopperWrapper} {
        background-color: rgba(0, 0, 0, 0.5);
        color: ${mlbWhite};
        border: 0;
        width: 150px;
        padding: 8px;
        text-align: center;
    }

`;

export const HowToWrapper = styled.div`
    font-family: var(--gameday-primary-font);
    width: 100%;
    height: 48px;
    background: ${mlbGrey2};
    font-weight: 700;
    font-size: 14px;
    line-height: 14px;
    letter-spacing: 0.38px;
    line-height: 48px;
    display: flex;
    justify-content: space-between;

    > div {
        height: 48px;
        padding-left: 16px;

        &:last-child {
            text-align: right;
            padding-right: 16px;

            button {
                padding: 0;
                vertical-align: top;
                border-radius: 0;
            }
        }
    }
`;

export const AccountWrapper = styled.div`
    ${({ $type }) => {
        if ($type === TYPES.PREVIEW) {
            return `
                form {
                    display: none;
                }

                .login-subheader {
                    display: none;
                }

                #OKTASignin {
                  .auth-content {
                    margin-top: -40px !important;
                  }
                }
            `;
        }

        if ($type === TYPES.LOGIN) {
            return `
                form {
                    margin-left: 32px;
                    margin-right: 32px;

                    #okta-signin-username,
                    #okta-signin-password {
                        width: 82% !important;
                        padding: 0 0 0 16px;!important;
                    }

                }
            `;
        }
    }};

    .register__container {
        background-color: var(--gameday-background-color);
        color: var(--gameday-secondary-font-color);
        .connect__input-label {
            color: var(--gameday-secondary-font-color);
        }
        .connect__login-back {
            .back-to {
                color: var(--gameday-fv-login-link-color);
            }
        }
        .connect__input-group,
        .connect__input-group-inline {
            .connect__input {
                background-color: var(--gameday-background-color);
                border: solid 1px var(--gameday-divider-color);

            }
            .connect__input--password-prompt {
                ${PopperWrapper} {
                    border: solid 1px var(--gameday-fv-login-password-modal-bg);
                    background-color: var(--gameday-fv-login-password-modal-bg);
                    ${PopoverArrow} {
                        ::before {
                            border-bottom: 1em solid var(--gameday-fv-login-password-modal-bg);
                        }
                        ::after {
                            border-bottom: 1em solid var(--gameday-fv-login-password-modal-bg);
                        }
                    }
                    .connect__prompt {
                        background-color: var(--gameday-fv-login-password-modal-bg);
                        color: var(--gameday-fv-login-password-modal-text);
                    }
                }
            }
        }
    }

    .login__section {
        width: 100% !important;
        max-width: ${XS};
        background-color: var(--gameday-background-color) !important;
    }

    .login__container {
        font-family: var(--gameday-primary-font);
        margin-top: 0px !important;
        background-color: var(--gameday-background-color);
        color: var(--gameday-primary-font-color);

        .auth-footer,
        .registration-container,
        .password-container {
            font-size: 15px;
            color: var( --gameday-fv-login-link-color);

            a {
                color: var( --gameday-fv-login-link-color) !important;
            }
        }
        .registration-label {
            font-size: 15px !important;
            color: var(--gameday-primary-font-color) !important;
        }
        .login-subheader {
            font-family: var(--gameday-primary-font);
            font-size: 17px;
            line-height: 22px;
            font-weight: normal;
            color: var(--gameday-primary-font-color);
        }
        #OKTASignin {
            width: 100%;
            padding-bottom: 0;

            .content-container {
                padding-top: 16px !important;
                padding-bottom: 16px !important;
                margin-top: 0 !important;
                margin-right: 32px;
                margin-left: 32px;
                border-top: solid 1px var(--gameday-divider-color) !important;


                a.registration-link {
                    font-weight: normal;
                    font-size: 15px !important;
                    color: var( --gameday-fv-login-link-color);
                }
            }
            input::placeholder {
                color: var(--gameday-secondary-font-color);
            }
            #okta-signin-password,
            #okta-signin-username {
                background-color: var(--gameday-background-color);
                border: solid 1px var(--gameday-divider-color);
            }
            .okta-form-input-error {
                color: var(--gameday-red) !important;
            }
        }

    }
`;

export const LogInWrapper = styled.div`
    background-color: var(--gameday-background-color);
    ${({ $type }) => {
        if ($type === TYPES.REGISTER) {
            return `
                display: none;
            `;
        }

        if ($type === TYPES.PREVIEW) {
            return `
                ${TitleWrapper} {
                    display: none;
                }
            `;
        }
    }};
`;

export const RegisterWrapper = styled.div``;

export const LogInButton = styled(Button)`
    width: 208px;
    height: 48px;
    border-radius: 28px;
    width: 50%;
    margin-bottom: 16px;
    font-size: 16px;

`;

export const FVLink = styled(Link)`
    display:block;
    height: 32px;
    width:100%;
    line-height:32px;
    text-align:center;
    font-size:20px;
    font-weight:700;
    color: var(--gameday-primary-font-color) !important;
    background-color: rgba(0, 0, 0, 0.5);
    &:hover {
        color: var(--gameday-link-color) !important;
    }
`;

export const FVButton = styled.div`
    z-index: 1;
    display: inline-block;
    position: absolute;
    top: 16px;
    right: 16px;
    cursor: pointer;
    font-family: var(--gameday-primary-font);
    > div {
        height: 32px;
        width: 32px;
        border-radius: 50%;
        overflow:hidden;
        box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.2);

        svg {
            line-height: 32px;
            height: 32px;
            fill: ${mlbWhite};
            path {
                fill: ${mlbWhite};
            }
        }

        @media (hover: hover){
            a {
                &:hover {
                     svg {
                         fill: var(--gameday-link-color) !important;
                         path {
                            fill: var(--gameday-link-color) !important;
                         }
                     }
                }
            }
        }

    }

    ${({ $buttonType }) => {
        if ($buttonType === ButtonTypes.CAMERA) {
            return `
               top: auto;
               bottom: 16px;
            `;
        }

        if ($buttonType === ButtonTypes.TUTORIAL) {
            return `
               top: auto;
               bottom: 97px;
            `;
        }
    }};
`;

export const TitleWrapper = styled.div`
    font-family: var(--gameday-primary-font);
    color: var(--gameday-primary-font-color);
    width: 100%;
    font-size:17px;
    text-align: center;
    padding-top: 0px;
    padding-bottom: 20px;
    border-bottom: 1px solid var(--gameday-divider-color);
`;

export const ThingsToKnowWrapper = styled.ul`
    font-family: var(--gameday-primary-font);
    color: var(--gameday-primary-font-color);
    font-size:18px;
    font-weight: normal;
    padding: 0 16px;
    margin: -20px 0 0 16px;
    list-style: circle outside;
    display: flex;
    flex-direction: column;
    flex: 1 1 100%;
    align-items: stretch;
    justify-content: center;
    box-sizing: border-box;
    li {
        padding-left: 20px;
        padding-bottom: 40px;
    }
`;

export const PreviewWrapper = styled.div`
    font-family: var(--gameday-primary-font) !important;
    font-size: 17px;
    line-height: 22px;
    color: var(--gameday-primary-font-color);
    text-align: center;
    header {
        margin-bottom: 20px;
        font-weight: 700;
        width: 100%;
    }
`;

export const CopyWrapper = styled.div`
    font-family: var(--gameday-primary-font) !important;
    font-weight:normal;
    margin: 16px auto;
    margin: 16px 32px;
`;

export const InfoDivider = styled.div`
    height: 1px;
    background-color: var(--gameday-divider-color);
    margin: 16px 32px;
`;

export const InfoWrapper = styled.div`
    font-size: 15px;
    line-height: 100%;
    color: ${mlbBlack};

    a {
        color: ${blueRibbon};
    }
`;

export const ExploreWrapper = styled.div`
    font-family: var(--gameday-primary-font) !important;
    max-width: 375px;
    margin: 0 auto;
    min-height: 600px;
    display: flex;
    flex-direction: column;

    ${TitleWrapper} {
        font-size: 18px;
        line-height: 22px;
        border:0;
        font-weight: 700;
        flex: 0 1 auto;
        align-self: start;
    }
`;

export const DemoWrapper = styled.div`
    font-family: var(--gameday-primary-font) !important;
    width: 286px;
    margin: 0 auto 24px auto;
    text-align: center;

    img {
        display: block;
        filter: invert(var(--gameday-fv-how-to-img-filter));
    }

    div {
        font-size: 16px;

        &.info {
            color: var(--gameday-secondary-font-color);
            font-size: 13px;
            line-height: 115%;
        }

        &.title {
            font-weight: 700;
            font-size: 14px;
            line-height: 115%;
            text-transform: uppercase;
            margin-top: 18px;
            color: var(--gameday-fv-how-to-title-color);
        }
    }
`;

export const PaginationDot = styled(StyledDotSVG)`
    fill: ${({ active }) => active ? 'var(--gameday-active-icon-button-color)' : 'var(--gameday-inactive-icon-button-color)'};
    margin: 4px;
    opacity: 1;
`;

export const PaginationDots = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    padding-bottom: ${({ $isMobile }) => $isMobile ? '16px' : ''}
`;

export const PaginationButtons = styled.div`
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    display: flex;
    align-items: center;

    button {
        color: var(--gameday-active-icon-button-color);
        background-color: transparent !important;
        svg {
            fill: var(--gameday-active-icon-button-color);
            use {
                symbol {
                    path {
                        fill: var(--gameday-active-icon-button-color);
                        stroke: var(--gameday-active-icon-button-color);
                    }
                }
            }
        }
        &:hover {
            background-color: transparent;
            color: var(--gameday-active-icon-button-color);
            svg {
                fill: var(--gameday-active-icon-button-color);
                use {
                    symbol {
                        path {
                            fill: var(--gameday-active-icon-button-color);
                            stroke: var(--gameday-active-icon-button-color);
                        }
                    }
                }
            }
        }
        &:disabled {
            color: var(--gameday-inactive-icon-button-color);
            svg {
                use {
                    symbol {
                        path {
                            fill: var(--gameday-inactive-icon-button-color);
                        }
                    }
                }
            }
        }
    }
`;

export const CarouselControlsWrapper = styled.div`
    border-top: 1px solid var(--gameday-divider-color);
    height: ${({ $isMobile }) => $isMobile ? '72px' : '56px'};
    position: absolute;
    bottom: 0;
    width: 100%;
`;

export const CarouselWrapper = styled.div`
    ${StyledCarousel} {
        max-height: ${({ $isMobile }) => $isMobile ? 'calc(100% - 56px - 16px)' : 'calc(100% - 56px)'};
        position: relative;
        overflow-y: auto;
    }
    height: calc(100% - 20px);
    overflow-y: auto;
`;

export const FieldVisionsLoadingScreen = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: ${mlbBlack};
    z-index: 1;
    &::after {
        position: relative;
        content: " ";
        display: block;
        width: 64px;
        height: 64px;
        top: calc(50% - 32px);
        left: calc(50% - 32px);
        margin: 8px;
        border-radius: 50%;
        border: 6px solid ${mlbWhite};
        border-color: ${mlbWhite} rgba(0, 0, 0, 0) ${mlbWhite} rgba(0, 0, 0, 0);
        animation: ${LoadingSpinnerKeyFrames} 1.2s linear infinite;
    }
`;

export const FieldVisionAppWrapper = styled.div`
    position: relative;
    width: 100%;
    white-space: normal;
    overflow-y: hidden;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    align-content: stretch;
`;

export const PlayerDuelScoresWrapper = styled.div`
    width: 373px;
    height: auto;
    background: var(--gameday-background-color);
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.25);
    border-radius: 5px;
    border: 1px solid var(--gameday-matchup-outline-color);
`;

export const GamedayLiveDesktopWrapper = styled.div`
    position: absolute;
    top:21px;
    left: 16px;
    z-index: 1;

    ${ChipWrapper} {
        animation: 8.5s ${ChipAnim} ease-out;
        opacity: 0;
        transform: translateY(0);
        border: 1px solid var(--gameday-matchup-outline-color);
    }

    ${ChipWrapperFlex} {
        animation: 8.5s ${ChipAnim} ease-out;
        opacity: 0;
        transform: translateY(0);
        border: 1px solid var(--gameday-matchup-outline-color);
    }

    ${TeamSummaryMatchUpWrapper} {
        border-bottom: 1px solid var(--gameday-divider-color);   
    }
`;
export const GamedayMobileTeamMatchupWrapper = styled.div`
    background-color: var(--gameday-background-color);
`;

export const FieldVisionApp = styled.div`
    width: 100%;
    position: relative;
    background: ${mlbBlack};
    overflow: hidden;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    align-content: stretch;

    ${ModalContainer} {
        z-index: 1;
        position: absolute;

        ${CloseButton} {
            position: absolute;
            height: 17.35px;
            right: 22px;
            top: 22px;
            margin-top: 0;
        }
    }
`;

export const FvodApp = styled.div`
    position: relative;
    width: 100%;
    height: 96%;
    margin: 8px 0;
    background: ${mlbBlack};
    border-radius: 5px;
    overflow: hidden;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    align-content: stretch;

    @media (max-width: ${ATBAT_MODAL_BREAKPOINT}) {
        margin-top: var(--gameday-section-padding-sm);
        height: 185px;
    }
`;

export const GamedayLiveMobileWrapper = styled.div`
    background-color: var(--gameday-background-color);

    ${MainWrapper} {
        margin-top: 0;
    }

    ${UpcomingBattersContainer} {
        margin-bottom: 0;
        padding-bottom: 8px;
    }
    
`;

export const NoOktaWrapper = styled.div`
    font-family: var(--gameday-primary-font);
    font-weight: 700;
    font-size: 16px;
    line-height: 21px;
    width: calc(100% - 32px);
    max-width: 327px;
    margin-left: 16px;
    margin-top:10px;
    text-align: center;
`;
